import { StytchHeadlessClient } from "@stytch/vanilla-js/headless";
import { AppConfig } from "shared/config/AppConfig";

export const appStytchClient = AppConfig.stytch
  ? new StytchHeadlessClient(AppConfig.stytch.projectId)
  : ({} as StytchHeadlessClient);
